import React from 'react';
import './ReturnRefundPolicy.css';

const ReturnRefundPolicy = () => {
    return (
        <div className="return-refund-container">
            <h1>Return/Refund or Exchange Policy</h1>
            <p>Triple A's Technology appreciates your patronage. However, if you are not completely satisfied with the product purchased, feel free to read our return/refund or exchange policy below. All returned product(s) must be in new and unused condition, with all original tags, serial numbers, and labels attached.</p>
            
            <h2>Return Process</h2>
            <p>To return an item or items, please email customer service at <a href="">Tripleastechnology.com</a> or call the office line to obtain a Return Merchandise Authorization (RMA) number. Afterwards, keep the item safe from scratches and dirt.</p>
            
            <h2>Refund Policy</h2>
            <p>After all verifications of the returns by the supervisor, the item can be processed for return or exchange. Depending on the nature of the return, there may be an instant ratification or days of processing before an exchange or refund.</p>
            
            <h2>Exceptions</h2>
            <p>For factory defective product(s), please contact the number below for proper exchange or refund.</p>
            <p><strong>Note:</strong> We have the ability to determine such defects, whether factory or self-damage. Invoices of purchase MUST be presented before any return or exchange. If none of these meet your needs, kindly call the customer care number.</p>
            
            <h2>Payment Before Delivery</h2>
            <p>Products remain the property of Triple A's Technology until full payment is made.</p>
            <p>Products returned in good condition shall attract a 15% restocking surcharge.</p>
            <p>Customers are advised to check their products before leaving any of our offices or before the delivery personnel leaves, because we take no responsibility for accepting products not returned within 24 hours within Lagos State and 72 hours outside Lagos State.</p>
            
            <p>We appreciate your understanding and constant patronage.</p>
        </div>
    );
};

export default ReturnRefundPolicy;

